var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.columnData[_vm.columnDefinition.name])?_c('div',[_c('span',[_vm._v(_vm._s(_vm.momentRef(_vm.columnData[_vm.columnDefinition.name]).tz(_vm.tz).format(_vm.dateFormat)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }